module.exports = __webpack_public_path__ + "img/notFount.72e64362.png";